/** Product media may use an absolute URL or a path on the configured media host. */
export function resolveProductImageUrl(url?: string): string | undefined {
  if (!url) return undefined;
  if (/^(https?:\/\/|\/\/|data:)/.test(url)) return url;
  return `${(import.meta as any).env?.VITE_FRONTEND_BASE_URL ?? ''}${url}`;
}
